/**
 * Low-cardinality route label for application metrics.
 *
 * Events and logs keep the exact path for investigation. Metrics must not:
 * every slug/UUID would create a permanent new time series.
 */
export function telemetryRouteGroup(pathname: string | undefined) {
  if (!pathname) return "unknown";

  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return "/";

  if (segments[0] === "h") {
    if (segments[2] === "events") {
      return segments.length >= 5
        ? "/h/[hiive]/events/[event]/[subpage]"
        : "/h/[hiive]/events/[event]";
    }
    return "/h/[hiive]";
  }

  if (segments[0] === "chat") return "/chat/[id]";
  if (segments[0] === "profile" && segments.length > 1) {
    return "/profile/[user]";
  }
  if (segments[0] === "t") return "/t/[ticket]";
  if (segments[0] === "queen") return "/queen/[workspace]";
  if (segments[0] === "admin") return "/admin/[section]";

  return `/${segments.slice(0, 2).join("/")}`;
}
